import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout.tsx';
import { WelcomeSection } from '@/components/sections/WelcomeSection.tsx';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Falmouth Airpark</title>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="generator" content="Modern React App" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta name="description" content="Official website of Falmouth Airpark, located in Falmouth, MA on Cape Cod. Hangar rentals, pilot information, and Swift Fuel UL94 available." />
        <meta name="keywords" content="Falmouth Airpark, aviation, Cape Cod, hangar rental, pilot, Swift Fuel UL94, Massachusetts airport" />
        <style>
          {`
            body {
              font-family: Arial, sans-serif;
            }
          `}
        </style>
      </Helmet>
      
      <Layout>
        <WelcomeSection />
      </Layout>
    </>
  );
}